const isDev = process.env.NODE_ENV !== 'production'

// eslint-disable-next-line no-console -- Dev-only logger utility
export const logger = isDev ? console.log : () => {}
